'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Dnd = require('./Dnd');

var _Dnd2 = _interopRequireDefault(_Dnd);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _Dnd2["default"];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/bee-dnd/build/index.js
// module id = 140
// module chunks = 0